// extracted by mini-css-extract-plugin
export var addToCartButton = "_sg-b";
export var arrowButtonContainer = "_sg-9";
export var arrowButtonIcon = "_sg-a";
export var carouselArrowButton = "_sg-6";
export var carouselElementContainer = "_sg-1";
export var galleryThumbnail = "_sg-d";
export var galleryThumbnailImage = "_sg-e";
export var left = "_sg-7";
export var productDisplayCarouselContainer = "_sg-0";
export var productTileContainer = "_sg-2";
export var productTileImage = "_sg-4";
export var productTileImageContainer = "_sg-3";
export var productTileTitle = "_sg-5";
export var right = "_sg-8";
export var sliderOverflow = "_sg-c";